import { MainProduct } from "../../../types"

const isExcludeDate = (currentDate: Date) => {
  const EXCLUDE_DATES = window.EXCLUDE_DATES ?? []
  const dataExcludeDates = EXCLUDE_DATES.map((date: string) => date.trim()).filter((date: string) => date)
  if (!dataExcludeDates.length) {
    return false
  }
  return dataExcludeDates.some((date: string) => date === currentDate.toLocaleDateString("en-GB", { month: '2-digit', day: '2-digit' }))
}

// Format estimatedDispatchDate to be in the format: X day, Xth X month
const nthNumber = (number: number) => {
  if (number > 3 && number < 21) return 'th'
  switch (number % 10) {
    case 1:
      return 'st'
    case 2:
      return 'nd'
    case 3:
      return 'rd'
    default:
      return 'th'
  }
}

export const formatDate = (date: Date) => {
  const weekday = date.toLocaleString('en-AU', { weekday: 'long' })
  const day = date.getDate()
  const month = date.toLocaleString('en-AU', { month: 'long' })
  return `${weekday}, ${day}${nthNumber(day)} ${month}`
}


// Add number of businesss day (numberOfBusinessDays) to todays date (currentDate) and account for weekends
// CDSD-27910 logic copied over from business-date-inherits.js
export const addBusinessDays = (date: Date, days: number) => {
  const currentDate = new Date(date.valueOf())
  let isExclude = false

  for (let i = 1; i <= days; i++) {
    if (days === 1) {
      if(!isExclude) currentDate.setDate(currentDate.getDate() + 1);

      if(isExcludeDate(currentDate)) isExclude = false

      if (currentDate.getDay() === 6) {
        currentDate.setDate(currentDate.getDate() + 2);
      } else if (currentDate.getDay() === 0) {
        currentDate.setDate(currentDate.getDate() + 1);
      }
      if (isExcludeDate(currentDate)) {
        i--;
        isExclude = true
        currentDate.setDate(currentDate.getDate() + 1);
      }
    } else {
      currentDate.setDate(currentDate.getDate() + 1);
      if (currentDate.getDay() === 6) {
        currentDate.setDate(currentDate.getDate() + 2);
      } else if (currentDate.getDay() === 0) {
        currentDate.setDate(currentDate.getDate() + 1);
      }
      if (isExcludeDate(currentDate)) {
        i--;
      }
    }
  }

  return currentDate
}

const addBusinessDay = (number: number) => {
  const currentDate = new Date()
  let isExclude = false
  for (let i = 1; i <= number; i++) {
    if (number === 1) {
      if(!isExclude) currentDate.setDate(currentDate.getDate() + 1);

      if(isExcludeDate(currentDate)) isExclude = false

      if (currentDate.getDay() === 6) {
        currentDate.setDate(currentDate.getDate() + 2);
      } else if (currentDate.getDay() === 0) {
        currentDate.setDate(currentDate.getDate() + 1);
      }
      if (isExcludeDate(currentDate)) {
        i--;
        isExclude = true
        currentDate.setDate(currentDate.getDate() + 1);
      }
    } else {
      currentDate.setDate(currentDate.getDate() + 1);
      if (currentDate.getDay() === 6) {
        currentDate.setDate(currentDate.getDate() + 2);
      } else if (currentDate.getDay() === 0) {
        currentDate.setDate(currentDate.getDate() + 1);
      }
      if (isExcludeDate(currentDate)) {
        i--;
      }
    }
  }
  return currentDate
}

export const formatReadyWord = () => {
  const DISPATCH_NEXT_DAY = 'Estimated dispatch:'
  const DISPATCH_SAME_DAY = 'Same day dispatch'
  const date = new Date()
  const hourSydney = Number(date.toLocaleString('en-GB', { hour: '2-digit', timeZone: 'Australia/Sydney' }))
  const sameDayHourCutoff = Number(window.SAME_DAY_HOUR_CUTOFF ?? 10)
  let inventoryMessageDefault = null
  if (hourSydney < sameDayHourCutoff) {
    inventoryMessageDefault = DISPATCH_SAME_DAY
  } else {
    const dateAdded = addBusinessDay(1)
    inventoryMessageDefault = DISPATCH_NEXT_DAY + ' ' + formatDate(dateAdded)
  }

  return inventoryMessageDefault
}

export const getProductionDate = (mainProduct: MainProduct) => {
  // @Example:
  // Production Time_15 business days
  const tag = (mainProduct.tags || []).find((tag) => tag.includes('Production Time'))

  if (!tag) return ''

  const currentDate = new Date()
  // get second part of productionTimeTag
  const productionTime = tag.split('_')
  // get number of productionTimeTag
  const productionTimeNumber = productionTime[1].split(' ')[0]
  const numberOfBusinessDays = Number(productionTimeNumber)
  const estimatedDispatchDate = addBusinessDays(currentDate, numberOfBusinessDays)
  const formattedDate = formatDate(estimatedDispatchDate)

  return `${formattedDate}`
}